// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import infiniteScroll from "./infiniteScroll";
import themeToggle from "./themeToggle";

// Call the infinite scroll and theme toggle functions
infiniteScroll();
themeToggle();
